import { render, staticRenderFns } from "./check.vue?vue&type=template&id=a0361090&scoped=true"
import script from "./check.vue?vue&type=script&lang=js"
export * from "./check.vue?vue&type=script&lang=js"
import style0 from "./check.vue?vue&type=style&index=0&id=a0361090&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0361090",
  null
  
)

export default component.exports